<template>
  <div
    class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 pr-under-md-0 pl-under-md-0">
    <div class="col-12 pl-0 pr-0 mb-1">
      <div class="styled-scrollbar-custom">
        <!--          region fake card-->
        <div class="fake-card-container mb-4">
          <div class="fake-card-image-container">
            <img :src="require(`@/assets/images/b122/fakeAnnonceImage.jpeg`)" alt="Veilleur" class="fake-card-image">
          </div>
          <div class="fake-card-values">
            <div>
              <div>
                <i v-for="index in 5" class="ph-star-fill main-color"></i>
              </div>
              <div class="fake-card-title w-75"></div>
              <div class="fake-card-title w-50"></div>
              <div class="fake-card-content w-25 mt-2"></div>
              <div class="fake-card-content w-50"></div>
            </div>
            <div class="fake-card-views"></div>
          </div>
        </div>
        <!--          endregion-->

        <div v-for="[key, value] of Object.entries(options)"
             :key="key"
             :class="'reward-boost-option-container mt-2 ' + (value.disabled ? ' reward-boost-option-disabled'  : '')"
             @click="changeSelectedOption(value)">
          <div class="d-flex flex-row">
            <b-form-radio
              v-model="selectedOption"
              :disabled="value.disabled"
              :value="value"
              @click.native.stop
            ></b-form-radio>
            <div>{{ key + " " + (key > 1 ? $t('stars') : $t('star')) }}</div>
          </div>
          <div v-if="!value.disabled" class="reward-boost-option-price">
            {{ value.customAmount ? $t('free') : (fromAnnonceCreation ? "+" : "") + (value.price + "€") }}
          </div>
        </div>

        <div v-if="selectedOption && selectedOption.customAmount" class="mt-2">
          <b-form-group :invalid-feedback="annonce.additionnalRewardAmount.invalidFeedback">
            <b-input-group>
              <b-form-input
                id="customAmountInput"
                ref="customAmountInput"
                v-model="customAmount"
                :formatter="formatCustomAmount"
                :invalid-feedback="annonce.additionnalRewardAmount.invalidFeedback"
                :min="options[5].price"
                :state="annonce.additionnalRewardAmount.state"
                class="border-right-0"
                lazy
                lazy-formatter
                type="number"
              ></b-form-input>
              <b-input-group-append>
                <b-input-group-text class="reward-boost-option-custom-amount-suffix">
                  €
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-invalid-feedback v-if="!annonce.additionnalRewardAmount.state"
                                   class="mb-2 d-flex">
            {{ annonce.additionnalRewardAmount.invalidFeedback }}
          </b-form-invalid-feedback>
        </div>
      </div>
    </div>
    <b-modal
      id="additional-reward-info-modal"
      ref="modal"
      centered
      class="additional-reward-info-modal"
      hide-footer
      hide-header>
      <div>
        <p class="page-title additional-reward-info-modal-title mt-0 mb-3"
           v-html="$t('additional.reward.know.more.modal.title')"></p>
        <p class="vin-info-text mt-2" v-html="$t('additional.reward.know.more.modal.description')"></p>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "AnnonceCreateAdditionalRewardStep",
  emits: ["updateAnnonce"],
  props: {
    annonce: {
      required: true,
      type: Object
    },
    fromAnnonceCreation: {
      default: false,
      type: Boolean,
    },
    needToDisableOptions: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      selectedOption: null,
      customAmount: null,
      options: {
        1: {
          index: 1,
          price: 200,
          customAmount: false,
          disabled: false,
        },
        2: {
          index: 2,
          price: 500,
          customAmount: false,
          disabled: false,
        },
        3: {
          index: 3,
          price: 800,
          customAmount: false,
          disabled: false,
        },
        4: {
          index: 4,
          price: 1100,
          customAmount: false,
          disabled: false,
        },
        5: {
          index: 5,
          price: 1400,
          customAmount: true,
          disabled: false,
        }
      }
    }
  },
  watch: {
    'selectedOption': function () {
      this.updateAnnonce()
    },
    'customAmount': function () {
      this.updateAnnonce()
    },
    'annonce.additionnalRewardLevel.value': function () {
      this.initValues()
    },
    'needToDisableOptions': function () {
      //Si on est pas dans la création d'annonce, on ne doit pas pouvoir sélectionner une
      //valeur inférieure à celle déjà sélectionnée
      if (!this.fromAnnonceCreation && this.needToDisableOptions) {
        for (const [key, value] of Object.entries(this.options).reverse()) {
          if (key <= this.annonce.additionnalRewardLevel.value) {
            value.disabled = true
          } else {
            //Si on modifie la récompense supplémentaire (annonce validée), il faut adapter les prix
            value.price -= this.options[this.annonce.additionnalRewardLevel.value].price
          }
        }
      }
    },
  },
  async mounted() {
    this.initValues()
  },
  methods: {
    formatCustomAmount(value) {
      if (value <= this.options[5].price) {
        return this.options[5].price
      } else {
        return Math.ceil(value)
      }
    },
    initValues() {
      if (this.annonce.additionnalRewardLevel.value !== null) {
        this.selectedOption = this.options[this.annonce.additionnalRewardLevel.value]
        if (this.selectedOption.index === 5 && this.annonce.additionnalRewardAmount.value) {
          this.customAmount = this.annonce.additionnalRewardAmount.value
        }
      }
    },
    updateAnnonce() {
      if (this.selectedOption === null && this.fromAnnonceCreation) {
        this.annonce.additionnalRewardLevel.value = null;
        this.annonce.additionnalRewardAmount.value = null;
      } else if (this.selectedOption) {
        if (this.selectedOption.index === 5) {
          if (this.customAmount === null || this.customAmount < this.options[5].price) {
            this.annonce.additionnalRewardAmount.invalidFeedback = `${this.$i18n.t('additional.reward.free.min')} ${this.options[5].price}€`;
            this.annonce.additionnalRewardAmount.state = false;
          } else {
            this.annonce.additionnalRewardAmount.invalidFeedback = null;
            this.annonce.additionnalRewardAmount.state = true;
            this.annonce.additionnalRewardAmount.value = this.customAmount;
          }
        } else {
          this.annonce.additionnalRewardAmount.value = this.selectedOption.price;
          this.annonce.additionnalRewardAmount.state = null;
          this.annonce.additionnalRewardAmount.invalidFeedback = null;
        }
        this.annonce.additionnalRewardLevel.value = this.selectedOption.index;
      } else {
        this.annonce.additionnalRewardAmount.value = null;
        this.annonce.additionnalRewardLevel.value = null;
        this.annonce.additionnalRewardAmount.invalidFeedback = null;
        this.annonce.additionnalRewardAmount.state = null;
      }
      this.$emit('updateAnnonce', this.annonce);
    },
    changeSelectedOption(option) {
      if (this.selectedOption === option && this.fromAnnonceCreation) {
        this.selectedOption = null
      } else {
        this.selectedOption = option
      }
      this.$nextTick(() => {
        if (this.selectedOption.customAmount) {
          this.$refs.customAmountInput.$el.scrollIntoView({behavior: 'smooth'});
        }
      });
    },
    handleChange(event) {
      console.log(event)
    }
  },
}
</script>

<style scoped>
.styled-scrollbar-custom {
  max-height: calc(100vh - 325px);
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreateAdditionalRewardStep.vue